@if (hasPlatformNewsAccess || hasLoginAgreementServiceAccess) {
  <div class="sc-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            @if (hasPlatformNewsAccess) {
              <sc-button class="sc-footer__service-agreement-btn" size="small" type="link" (onClick)="openNews()">Novedades en la plataforma</sc-button>
            }
            @if (hasPlatformNewsAccess && hasLoginAgreementServiceAccess) {
              <span class="align-text-bottom px-1">.</span>
            }
            @if (hasLoginAgreementServiceAccess) {
              <sc-button class="sc-footer__service-agreement-btn" size="small" type="link" (onClick)="openServiceAgreementModal()">Acuerdo de Servicio</sc-button>
            }
            @if (hasPlatformNewsAccess && hasLoginAgreementServiceAccess) {
              <span class="align-text-bottom px-1">.</span>
            }
            @if (hasLoginAgreementServiceAccess) {
              <sc-button class="sc-footer__service-agreement-btn" size="small" type="link" (onClick)='openDownloadBaremo()'>Baremos de daños</sc-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<sc-news-modal></sc-news-modal>
<sc-service-agreement-modal></sc-service-agreement-modal>
<sc-download-baremo-modal></sc-download-baremo-modal>
